import React from "react";
import variables from "../../styles/variables.scss";

export const AskHelpIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M11 14V16C9.4087 16 7.88258 16.6321 6.75736 17.7574C5.63214 18.8826 5 20.4087 5 22H3C3 19.8783 3.84285 17.8434 5.34315 16.3431C6.84344 14.8429 8.87827 14 11 14ZM11 13C7.685 13 5 10.315 5 7C5 3.685 7.685 1 11 1C14.315 1 17 3.685 17 7C17 10.315 14.315 13 11 13ZM11 11C13.21 11 15 9.21 15 7C15 4.79 13.21 3 11 3C8.79 3 7 4.79 7 7C7 9.21 8.79 11 11 11ZM17 21.5L14.061 23.045L14.622 19.773L12.245 17.455L15.531 16.977L17 14L18.47 16.977L21.755 17.455L19.378 19.773L19.938 23.045L17 21.5Z"
        fill={props.fill}
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="25" height="25" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PeopleIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 11 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 13.75C0.5 12.4239 1.02678 11.1521 1.96447 10.2145C2.90215 9.27678 4.17392 8.75 5.5 8.75C6.82608 8.75 8.09785 9.27678 9.03553 10.2145C9.97322 11.1521 10.5 12.4239 10.5 13.75H9.25C9.25 12.7554 8.85491 11.8016 8.15165 11.0983C7.44839 10.3951 6.49456 10 5.5 10C4.50544 10 3.55161 10.3951 2.84835 11.0983C2.14509 11.8016 1.75 12.7554 1.75 13.75H0.5ZM5.5 8.125C3.42812 8.125 1.75 6.44688 1.75 4.375C1.75 2.30312 3.42812 0.625 5.5 0.625C7.57188 0.625 9.25 2.30312 9.25 4.375C9.25 6.44688 7.57188 8.125 5.5 8.125ZM5.5 6.875C6.88125 6.875 8 5.75625 8 4.375C8 2.99375 6.88125 1.875 5.5 1.875C4.11875 1.875 3 2.99375 3 4.375C3 5.75625 4.11875 6.875 5.5 6.875Z"
      fill={props.fill}
    />
  </svg>
);

export const LikeIcon = () => (
  <svg
    width="1.5em"
    height="1.5em"
    viewBox="0 0 17 10"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.16305 13.6669L1.03505 7.53893C-0.418286 5.82693 -0.342286 3.25893 1.27038 1.64559C2.04372 0.872266 3.08088 0.419958 4.17378 0.379402C5.26669 0.338846 6.33452 0.713042 7.16305 1.42693C7.99074 0.713043 9.05763 0.338316 10.1499 0.377836C11.2422 0.417355 12.2793 0.868201 13.0532 1.64003C13.8271 2.41186 14.2808 3.44765 14.3233 4.53985C14.3658 5.63205 13.994 6.69996 13.2824 7.52959L7.16305 13.6669ZM12.271 6.66093C12.7636 6.08653 13.0209 5.34722 12.9914 4.59113C12.9619 3.83503 12.6478 3.11801 12.112 2.58373C11.5762 2.04944 10.8583 1.73736 10.1021 1.71001C9.34596 1.68267 8.60738 1.94207 8.03438 2.43626L7.16305 3.18826L6.29171 2.43626C5.71872 1.94207 4.98014 1.68267 4.22397 1.71001C3.46779 1.73736 2.74988 2.04944 2.21408 2.58373C1.67828 3.11801 1.36416 3.83503 1.33467 4.59113C1.30518 5.34722 1.56249 6.08653 2.05505 6.66093L2.13105 6.74893L7.16305 11.7816L12.195 6.74893L12.271 6.66093V6.66093Z"
      fill="currentColor"
    />
  </svg>
);

export const FilledLikeIcon = () => (
  <svg
    width="1.5em"
    height="1.5em"
    viewBox="0 0 17 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.16305 13.6669L1.03505 7.53893C-0.418286 5.82693 -0.342286 3.25893 1.27038 1.64559C2.04372 0.872266 3.08088 0.419958 4.17378 0.379402C5.26669 0.338846 6.33452 0.713042 7.16305 1.42693C7.99074 0.713043 9.05763 0.338316 10.1499 0.377836C11.2422 0.417355 12.2793 0.868201 13.0532 1.64003C13.8271 2.41186 14.2808 3.44765 14.3233 4.53985C14.3658 5.63205 13.994 6.69996 13.2824 7.52959L7.16305 13.6669ZM12.271 6.66093C12.7636 6.08653 13.0209 5.34722 12.9914 4.59113C12.9619 3.83503 12.6478 3.11801 12.112 2.58373C11.5762 2.04944 10.8583 1.73736 10.1021 1.71001C9.34596 1.68267 8.60738 1.94207 8.03438 2.43626L7.16305 3.18826L6.29171 2.43626C5.71872 1.94207 4.98014 1.68267 4.22397 1.71001C3.46779 1.73736 2.74988 2.04944 2.21408 2.58373C1.67828 3.11801 1.36416 3.83503 1.33467 4.59113C1.30518 5.34722 1.56249 6.08653 2.05505 6.66093L2.13105 6.74893L7.16305 11.7816L12.195 6.74893L12.271 6.66093Z"
      fill="#F63F41"
    />
    <path
      d="M1 4L1.5 2.5L3.78563 1.58575L5.5 1.5L6.5 2.5L7.5 2L8.5 1.5L10 1L12 1.5L13 2.5L13.5 3.5V5L13 6.5L7 12L3.5 8.5L1.5 6.5L1 5.5V4Z"
      fill="#FF5E61"
    />
  </svg>
);

export const SuperListIcon = (props) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10.5" cy="10.5" r="10.5" fill={variables.primaryColor} />
    <path
      d="M6.85742 7.71387L6.85742 13.4281"
      stroke="white"
      strokeWidth="1.4"
    />
    <path d="M4 10.5713L9.71427 10.5713" stroke="white" strokeWidth="1.4" />
    <path
      d="M6.85742 5.42871H16.0003V15.7144H6.85742"
      stroke="white"
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
    <path d="M9.14258 8.28613H13.714" stroke="white" strokeWidth="1.4" />
    <path d="M10.8574 10.5723H13.7146" stroke="white" strokeWidth="1.4" />
    <path
      d="M9.14258 12.8584L13.714 12.8584"
      stroke="white"
      strokeWidth="1.4"
    />
  </svg>
);

export const CommentIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path
      d="M10 3h4a8 8 0 1 1 0 16v3.5c-5-2-12-5-12-11.5a8 8 0 0 1 8-8zm2 14h2a6 6 0 1 0 0-12h-4a6 6 0 0 0-6 6c0 3.61 2.462 5.966 8 8.48V17z"
      fill="currentColor"
    />
  </svg>
);

export const EyeIcon = (props) => (
  <svg
    width="16"
    height="10"
    viewBox="0 0 16 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00033 0C4.66699 0 1.82033 2.07333 0.666992 5C1.82033 7.92667 4.66699 10 8.00033 10C11.3337 10 14.1803 7.92667 15.3337 5C14.1803 2.07333 11.3337 0 8.00033 0ZM8.00033 8.33333C6.16033 8.33333 4.66699 6.84 4.66699 5C4.66699 3.16 6.16033 1.66667 8.00033 1.66667C9.84033 1.66667 11.3337 3.16 11.3337 5C11.3337 6.84 9.84033 8.33333 8.00033 8.33333ZM8.00033 3C6.89366 3 6.00033 3.89333 6.00033 5C6.00033 6.10667 6.89366 7 8.00033 7C9.10699 7 10.0003 6.10667 10.0003 5C10.0003 3.89333 9.10699 3 8.00033 3Z"
      fill={props.color}
    />
  </svg>
);

export const CloseIcon = (props) => (
  <svg
    style={props.style}
    width={props.width}
    height={props.height}
    className={props.className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
      fill="rgba(0 , 0 , 0 , 0.54)"
    />
  </svg>
);

export const RefreshIcon = (props) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2378 1.7625C9.15031 0.675 7.65781 0 6.00031 0C2.68531 0 0.0078125 2.685 0.0078125 6C0.0078125 9.315 2.68531 12 6.00031 12C8.79781 12 11.1303 10.0875 11.7978 7.5H10.2378C9.62281 9.2475 7.95781 10.5 6.00031 10.5C3.51781 10.5 1.50031 8.4825 1.50031 6C1.50031 3.5175 3.51781 1.5 6.00031 1.5C7.24531 1.5 8.35531 2.0175 9.16531 2.835L6.75031 5.25H12.0003V0L10.2378 1.7625Z"
      fill={variables.primaryColor}
    />
  </svg>
);

export const BackIcon = (props) => (
  <svg
    width={props.width ? props.width : 16}
    height={props.height ? props.height : 16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z"
      fill="black"
    />
  </svg>
);

export const Heading1Icon = (props) => (
  <svg
    style={{ verticalAlign: "text-top" }}
    width="18"
    height="18"
    viewBox="0 0 20 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="1">
      <path
        d="M14 15V0H10.6633V5.89205H3.31333V0H0V15H3.31333V8.70315H10.6633V15H14Z"
        fill={props.active ? variables.primaryColor : "#807e7e"}
      />
      <path
        d="M20 15V7H18.515L16 9.53073L16.9701 10.5502L18.2994 9.1949V15H20Z"
        fill={props.active ? variables.primaryColor : "#807e7e"}
      />
    </g>
  </svg>
);

export const Heading2Icon = (props) => (
  <svg
    style={{ verticalAlign: "text-top" }}
    width="18"
    height="18"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="1">
      <path
        d="M14 15V0H10.6633V5.89205H3.31333V0H0V15H3.31333V8.70315H10.6633V15H14Z"
        fill={props.active ? variables.primaryColor : "#807e7e"}
      />
      <path
        d="M21 15V13.8922H18.3694C20.0426 12.7755 20.9516 11.8981 20.9516 10.8877C20.9516 9.70901 19.8588 9 18.4855 9C17.5861 9 16.6286 9.30133 16 9.96603L16.7834 10.7991C17.2186 10.3826 17.7795 10.1167 18.5145 10.1167C19.0464 10.1167 19.559 10.3737 19.559 10.8877C19.559 11.6145 18.7853 12.226 16.1451 14.0162V15H21Z"
        fill={props.active ? variables.primaryColor : "#807e7e"}
      />
    </g>
  </svg>
);

export const SquareCheckBox = (props) => (
  <svg
    style={{ verticalAlign: "text-top", marginRight: "5px" }}
    width="18"
    height="18"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="1">
      <rect
        x="1"
        y="1"
        width="14"
        height="14"
        rx="1"
        stroke={props.active ? variables.primaryColor : "#807e7e"}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M5 8.18182L5.75 8.90909L6.875 10L10.25 6.72727L11 6"
        stroke={props.active ? variables.primaryColor : "#807e7e"}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const CircleCheckBox = (props) => (
  <svg
    style={{ verticalAlign: "text-top", marginRight: "5px" }}
    width="20"
    height="20"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      opacity="1"
      x="1"
      y="1"
      width="14"
      height="14"
      rx="7"
      stroke={props.active ? variables.primaryColor : "#807e7e"}
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      opacity="1"
      d="M5 8.18182L5.75 8.90909L6.875 10L10.25 6.72727L11 6"
      stroke={props.active ? variables.primaryColor : "#807e7e"}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CircleCheckBoxGreen = (props) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8.88373" r="8" fill="#82D1B5" fillOpacity="0.3" />
    <path
      d="M5.2002 9.6806L6.8002 11.2806L10.4002 7.6806"
      stroke="#3A962B"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Manager = (props) => (
  <svg
    style={{ verticalAlign: "middle" }}
    width="12"
    height="15"
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.52189 5.66C7.08486 5.66 8.35189 4.39297 8.35189 2.83C8.35189 1.26703 7.08486 0 5.52189 0C3.95893 0 2.69189 1.26703 2.69189 2.83C2.69189 4.39297 3.95893 5.66 5.52189 5.66Z"
      fill="#57585F"
    />
    <path
      d="M9.32189 7.00023C8.94189 7.00023 7.82189 6.79023 7.82189 6.79023C7.69511 6.74973 7.55882 6.81568 7.51189 6.94023L5.81189 11.6002C5.76633 11.7209 5.65084 11.8007 5.52189 11.8007C5.39294 11.8007 5.27746 11.7209 5.23189 11.6002L3.53189 6.94023C3.49383 6.84147 3.3977 6.77738 3.29189 6.78023C3.29189 6.78023 2.11189 6.94023 1.72189 7.00023C0.665131 7.32215 -0.0415066 8.31637 0.00189325 9.42023V13.3002C0.00155039 13.5743 0.113743 13.8366 0.312237 14.0256C0.510732 14.2147 0.778125 14.3139 1.05189 14.3002H10.0019C10.5647 14.3011 11.03 13.8621 11.0619 13.3002V9.41023C11.0743 8.31187 10.3684 7.33408 9.32189 7.00023Z"
      fill="#57585F"
    />
    <path
      d="M6.16175 6.69968C6.09203 6.62549 5.99346 6.58534 5.89175 6.58968H5.14175C5.04245 6.58247 4.94572 6.62339 4.88175 6.69968C4.79332 6.82205 4.79332 6.98732 4.88175 7.10968L5.28175 7.70968L5.00175 9.28968L5.37175 10.2897C5.38609 10.3356 5.42863 10.3669 5.47675 10.3669C5.52487 10.3669 5.56741 10.3356 5.58175 10.2897L5.95175 9.28968L5.80175 7.70968L6.20175 7.10968C6.27877 6.97881 6.26261 6.8132 6.16175 6.69968Z"
      fill="#57585F"
    />
  </svg>
);

export const TwoPeople = (props) => (
  <svg
    style={{ verticalAlign: "middle" }}
    width="20"
    height="20"
    viewBox="0 0 24 24"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2193 5.66C15.7823 5.66 17.0493 4.39297 17.0493 2.83C17.0493 1.26703 15.7823 0 14.2193 0C12.6563 0 11.3893 1.26703 11.3893 2.83C11.3893 4.39297 12.6563 5.66 14.2193 5.66ZM18.0193 7C17.6393 7 16.5193 6.79 16.5193 6.79C16.3925 6.74951 16.2562 6.81545 16.2093 6.94L14.5093 11.6C14.4637 11.7206 14.3483 11.8005 14.2193 11.8005C14.0904 11.8005 13.9749 11.7206 13.9293 11.6L12.2293 6.94C12.1912 6.84124 12.0951 6.77715 11.9893 6.78C11.9893 6.78 10.8093 6.94 10.4193 7C10.2724 7.04475 10.1323 7.10249 10 7.1717C10.2149 7.20792 10.4207 7.23597 10.5425 7.23597C11.4885 7.59098 12.1266 8.63076 12.1154 9.79872V13.9353C12.1092 14.064 12.0848 14.1867 12.0452 14.3H18.6993C19.2621 14.3009 19.7275 13.8619 19.7593 13.3V9.41C19.7717 8.31165 19.0658 7.33385 18.0193 7ZM14.5893 6.59C14.691 6.58565 14.7896 6.62581 14.8593 6.7C14.9602 6.81352 14.9763 6.97913 14.8993 7.11L14.4993 7.71L14.6493 9.29L14.2793 10.29C14.265 10.3359 14.2224 10.3672 14.1743 10.3672C14.1262 10.3672 14.0837 10.3359 14.0693 10.29L13.6993 9.29L13.9793 7.71L13.5793 7.11C13.4909 6.98764 13.4909 6.82236 13.5793 6.7C13.6433 6.62371 13.74 6.58279 13.8393 6.59H14.5893Z"
      fill="#57585F"
    />
    <path
      d="M5.52141 6.66C7.08437 6.66 8.35141 5.39297 8.35141 3.83C8.35141 2.26703 7.08437 1 5.52141 1C3.95844 1 2.69141 2.26703 2.69141 3.83C2.69141 5.39297 3.95844 6.66 5.52141 6.66Z"
      fill="#57585F"
    />
    <path
      d="M9.32189 7.99925C8.94189 7.99925 7.82189 7.78925 7.82189 7.78925C7.69511 7.74876 7.55882 7.8147 7.51189 7.93925L5.81189 12.5992C5.76633 12.7199 5.65084 12.7997 5.52189 12.7997C5.39294 12.7997 5.27746 12.7199 5.23189 12.5992L3.53189 7.93925C3.49383 7.84049 3.3977 7.7764 3.29189 7.77925C3.29189 7.77925 2.11189 7.93925 1.72189 7.99925C0.665131 8.32117 -0.0415066 9.31539 0.00189325 10.4192V14.2992C0.00155039 14.5734 0.113743 14.8356 0.312237 15.0246C0.510732 15.2137 0.778125 15.313 1.05189 15.2992H10.0019C10.5647 15.3002 11.03 14.8611 11.0619 14.2992V10.4092C11.0743 9.3109 10.3684 8.3331 9.32189 7.99925Z"
      fill="#57585F"
    />
    <path
      d="M6.16175 7.70066C6.09203 7.62647 5.99346 7.58631 5.89175 7.59066H5.14175C5.04245 7.58345 4.94572 7.62437 4.88175 7.70066C4.79332 7.82302 4.79332 7.9883 4.88175 8.11066L5.28175 8.71066L5.00175 10.2907L5.37175 11.2907C5.38609 11.3366 5.42863 11.3679 5.47675 11.3679C5.52487 11.3679 5.56741 11.3366 5.58175 11.2907L5.95175 10.2907L5.80175 8.71066L6.20175 8.11066C6.27877 7.97979 6.26261 7.81418 6.16175 7.70066Z"
      fill="#57585F"
    />
  </svg>
);

export const FilterIcon = (props) => (
  <svg
    {...props}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.51619 5.67046C4.64212 5.8075 4.71126 5.98651 4.71126 6.1717V11.6286C4.71126 11.957 5.10756 12.1237 5.34213 11.8928L6.86438 10.1483C7.06808 9.90386 7.18043 9.78285 7.18043 9.54089V6.17293C7.18043 5.98775 7.2508 5.80873 7.37549 5.67168L11.7434 0.932113C12.0706 0.576552 11.8188 0 11.3348 0H0.556865C0.0729078 0 -0.180182 0.575318 0.148218 0.932113L4.51619 5.67046Z"
      fill="#57585F"
    />
  </svg>
);

export const TimelineIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7Z"
      fill={variables.primaryColor}
    />
    <path
      d="M7.00078 9.8002C5.45438 9.8002 4.20078 8.54659 4.20078 7.0002C4.20078 5.4538 5.45438 4.2002 7.00078 4.2002C8.54718 4.2002 9.80078 5.4538 9.80078 7.0002C9.80078 8.54659 8.54718 9.8002 7.00078 9.8002Z"
      fill="white"
    />
  </svg>
);

export const ThumbsDownIcon = (props) => (
  <svg
    className={props.className}
    width={props.width ? props.width : "16"}
    height={props.height ? props.height : "16"}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.3">
      <path
        d="M14.1058 10.0114H10.259L10.7652 11.4286C11.1701 12.5421 10.8664 13.7569 9.85412 14.4655C9.65166 14.668 9.24674 14.668 8.84182 14.668C8.53813 14.5667 8.4369 14.4655 8.23443 14.263C8.23443 13.9594 8.1332 13.7569 8.1332 13.5544C8.03197 12.9471 7.72828 12.3397 7.22213 11.9347C6.51352 11.1249 4.08398 8.99906 4.08398 8.99906V1.10308H12.3849C13.1947 1.10308 13.9033 1.8117 13.9033 2.62154C13.9033 2.824 13.8021 3.12769 13.7009 3.33015C14.4095 3.73507 14.612 4.64615 14.207 5.35476C14.9156 5.75968 15.1181 6.67076 14.7132 7.37937C15.4218 7.88553 15.523 8.89783 15.0169 9.50521C14.7132 9.70767 14.4095 9.91014 14.1058 10.0114Z"
        fill="black"
      />
      <path
        d="M2.6665 8.69531V1.71041"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const ThumbsUpIcon = (props) => (
  <svg
    className={props.className}
    width={props.width ? props.width : "16"}
    height={props.height ? props.height : "16"}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.3">
      <path
        d="M14.1058 5.98863H10.259L10.7652 4.57141C11.1701 3.45787 10.8664 2.24311 9.85412 1.53449C9.65166 1.33203 9.24674 1.33203 8.84182 1.33203C8.53813 1.43326 8.4369 1.53449 8.23443 1.73695C8.23443 2.04064 8.1332 2.24311 8.1332 2.44557C8.03197 3.05295 7.72828 3.66033 7.22213 4.06525C6.51352 4.8751 4.08398 7.00094 4.08398 7.00094V14.8969H12.3849C13.1947 14.8969 13.9033 14.1883 13.9033 13.3785C13.9033 13.176 13.8021 12.8723 13.7009 12.6698C14.4095 12.2649 14.612 11.3539 14.207 10.6452C14.9156 10.2403 15.1181 9.32924 14.7132 8.62063C15.4218 8.11447 15.523 7.10217 15.0169 6.49479C14.7132 6.29233 14.4095 6.08986 14.1058 5.98863Z"
        fill="black"
      />
      <path
        d="M2.6665 7.30469V14.2896"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const ReminderIcon = (props) => (
  <svg
    style={props.style}
    width={props.width}
    height={props.height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.49219 12.0195C4.92969 12.982 6.06719 13.4195 7.11719 12.982C7.55469 12.807 7.90469 12.457 8.07969 12.0195H4.49219Z"
      fill="#8E9DB0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.51699 11.7566H11.0545C11.2295 11.7566 11.4045 11.5816 11.317 11.4941C11.4045 11.3191 11.317 11.1441 11.142 11.0566C10.8795 10.7941 10.617 10.5316 10.5295 10.1816C10.4854 10.0582 10.4431 9.93386 10.4028 9.80874C9.10529 9.45281 8.16708 8.2758 8.16708 6.85666C8.16708 5.87809 8.61318 5.01465 9.31556 4.45616C8.69332 3.51199 7.64404 2.88738 6.41699 2.8316C4.40449 2.7441 2.65449 4.3191 2.56699 6.3316C2.65449 7.6441 2.39199 8.9566 1.95449 10.1816C1.86699 10.5316 1.60449 10.7941 1.34199 11.0566C1.25449 11.1441 1.16699 11.3191 1.16699 11.4941C1.16699 11.6691 1.34199 11.7566 1.51699 11.7566Z"
      fill="#8E9DB0"
    />
    <path
      d="M11.2295 4.66797C10.0107 4.66797 9.04199 5.63672 9.04199 6.85547C9.04199 8.07422 10.0107 9.04297 11.2295 9.04297C12.4482 9.04297 13.417 8.07422 13.417 6.85547C13.417 5.63672 12.4482 4.66797 11.2295 4.66797Z"
      fill="#8E9DB0"
    />
    <path
      d="M11.292 5.23047V6.88672H12.3545"
      stroke="white"
      strokeWidth="0.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.24219 1.16797V1.69297"
      stroke="#8E9DB0"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CalendarIcon = (props) => (
  <svg
    style={props.style}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.54">
      <g clipPath="url(#clip0)">
        <path
          d="M4.14027 3.5357C3.89815 3.5357 3.7019 3.33945 3.7019 3.09734V0.438363C3.7019 0.19625 3.89815 0 4.14027 0C4.38238 0 4.57863 0.19625 4.57863 0.438363V3.09734C4.57863 3.33945 4.38238 3.5357 4.14027 3.5357Z"
          fill={props.color}
        />
        <path
          d="M9.85975 3.5357C9.61764 3.5357 9.42139 3.33945 9.42139 3.09734V0.438363C9.42139 0.19625 9.61764 0 9.85975 0C10.1019 0 10.2981 0.19625 10.2981 0.438363V3.09734C10.2981 3.33945 10.1019 3.5357 9.85975 3.5357Z"
          fill={props.color}
        />
        <path
          d="M0.664795 6.08203V12.1305C0.664795 13.1616 1.50363 14.0005 2.53471 14.0005H11.4654C12.4965 14.0005 13.3353 13.1616 13.3353 12.1305V6.08203H0.664795Z"
          fill={props.color}
        />
        <path
          d="M13.3353 5.20353V3.19807C13.3353 2.16699 12.4965 1.32815 11.4654 1.32815H11.1748V3.09599C11.1748 3.82115 10.5849 4.41108 9.85971 4.41108C9.13454 4.41108 8.54462 3.82115 8.54462 3.09599V1.32812H5.4555V3.09596C5.4555 3.82112 4.86557 4.41105 4.14041 4.41105C3.41525 4.41105 2.82532 3.82112 2.82532 3.09596V1.32812H2.53471C1.50363 1.32812 0.664795 2.16696 0.664795 3.19804V5.2035H13.3353V5.20353Z"
          fill={props.color}
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const StarIcon = (props) => (
  <svg
    width="54"
    height="53"
    viewBox="0 0 54 53"
    fill={"none"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity={props.opacity}
      d="M25.1735 2.09812C25.8783 0.517143 28.1223 0.517142 28.827 2.09812L35.0947 16.1592C35.3854 16.8113 36.0016 17.2589 36.7116 17.3339L52.0213 18.9497C53.7426 19.1314 54.4361 21.2656 53.1503 22.4244L41.7142 32.7305C41.1839 33.2084 40.9485 33.9328 41.0966 34.6311L44.2908 49.6909C44.65 51.3841 42.8345 52.7031 41.3351 51.8383L27.9995 44.1467C27.3811 43.7901 26.6195 43.7901 26.001 44.1467L12.6654 51.8383C11.166 52.7031 9.35058 51.3841 9.70972 49.6909L12.9039 34.6311C13.052 33.9328 12.8167 33.2084 12.2864 32.7305L0.85031 22.4244C-0.435516 21.2656 0.257927 19.1314 1.97929 18.9497L17.289 17.3339C17.999 17.2589 18.6152 16.8113 18.9058 16.1592L25.1735 2.09812Z"
      fill={props.color}
    />
  </svg>
);

export const PersonIcon = (props) => (
  <svg
    style={props.style}
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2689 13.9981H0.721701C0.28868 13.9981 0 13.7094 0 13.2764V11.4C0 10.534 0.577361 9.66792 1.4434 9.2349C3.89718 8.08018 3.75284 8.22452 4.04152 8.22452H4.76322C5.05191 8.22452 5.34058 8.36886 5.34058 8.65754C5.48492 9.2349 6.06229 9.66792 6.63965 9.52358C7.21701 9.52358 7.50569 9.2349 7.65003 8.80188C7.65003 8.5132 7.93871 8.36886 8.22739 8.36886C9.09343 8.36886 9.09343 8.36886 9.23777 8.36886L11.5472 9.2349C12.4133 9.66792 12.8463 10.534 12.8463 11.4V13.2764C12.8463 13.7094 12.5576 13.9981 12.2689 13.9981Z"
      fill={props.color}
    />
    <path
      d="M6.49514 0C4.33004 0 2.45361 1.87642 2.45361 4.04152C2.45361 6.20663 4.33004 8.08305 6.49514 8.08305C8.66024 8.08305 10.5367 6.35097 10.5367 4.04152C10.5367 1.87642 8.66024 0.14434 6.49514 0Z"
      fill={props.color}
    />
  </svg>
);

export const ClockIcon = (props) => (
  <svg
    style={props.style}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.54">
      <g clipPath="url(#clip0)">
        <path
          d="M7 0C5.61553 0 4.26216 0.410543 3.11101 1.17971C1.95987 1.94888 1.06266 3.04213 0.532846 4.32122C0.003033 5.6003 -0.13559 7.00777 0.134506 8.36563C0.404603 9.7235 1.07129 10.9708 2.05026 11.9497C3.02922 12.9287 4.2765 13.5954 5.63437 13.8655C6.99224 14.1356 8.3997 13.997 9.67879 13.4672C10.9579 12.9373 12.0511 12.0401 12.8203 10.889C13.5895 9.73785 14 8.38447 14 7C14 5.14348 13.2625 3.36301 11.9498 2.05025C10.637 0.737498 8.85652 0 7 0V0ZM10.2667 7.46667H6.53334V1.86667H7.46667V6.53333H10.2667V7.46667Z"
          fill={props.color}
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BoxIcon = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="12"
      height="12"
      rx="3"
      fill={props.color ? props.color : "#FFCB3A"}
    />
  </svg>
);

export const LongArrowRight = (props) => (
  <svg
    style={props.style}
    width="24"
    height="8"
    viewBox="0 0 24 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.54"
      d="M1 3.5C0.723858 3.5 0.5 3.72386 0.5 4C0.5 4.27614 0.723858 4.5 1 4.5V3.5ZM23.3536 4.35355C23.5488 4.15829 23.5488 3.84171 23.3536 3.64645L20.1716 0.464466C19.9763 0.269204 19.6597 0.269204 19.4645 0.464466C19.2692 0.659728 19.2692 0.976311 19.4645 1.17157L22.2929 4L19.4645 6.82843C19.2692 7.02369 19.2692 7.34027 19.4645 7.53553C19.6597 7.7308 19.9763 7.7308 20.1716 7.53553L23.3536 4.35355ZM1 4.5H23V3.5H1V4.5Z"
      fill="black"
    />
  </svg>
);

export const LongArrowLeft = (props) => (
  <svg
    style={props.style}
    width="24"
    height="8"
    viewBox="0 0 24 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.54"
      d="M23 3.5C23.2761 3.5 23.5 3.72386 23.5 4C23.5 4.27614 23.2761 4.5 23 4.5V3.5ZM0.646446 4.35355C0.451185 4.15829 0.451185 3.84171 0.646446 3.64645L3.82843 0.464466C4.02369 0.269204 4.34027 0.269204 4.53553 0.464466C4.7308 0.659728 4.7308 0.976311 4.53553 1.17157L1.70711 4L4.53553 6.82843C4.7308 7.02369 4.7308 7.34027 4.53553 7.53553C4.34027 7.7308 4.02369 7.7308 3.82843 7.53553L0.646446 4.35355ZM23 4.5H1V3.5H23V4.5Z"
      fill="black"
    />
  </svg>
);

export const TimeIcon = (props) => (
  <svg
    style={props.style}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.8">
      <g clipPath="url(#clip0)">
        <path
          opacity="0.8"
          d="M6 0C4.81331 0 3.65328 0.351894 2.66658 1.01118C1.67989 1.67047 0.910851 2.60754 0.456726 3.7039C0.00259972 4.80026 -0.11622 6.00666 0.115291 7.17054C0.346802 8.33443 0.918247 9.40353 1.75736 10.2426C2.59648 11.0818 3.66557 11.6532 4.82946 11.8847C5.99335 12.1162 7.19975 11.9974 8.2961 11.5433C9.39246 11.0892 10.3295 10.3201 10.9888 9.33342C11.6481 8.34673 12 7.18669 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11743 0.632141 7.5913 0 6 0V0ZM8.8 6.4H5.6V1.6H6.4V5.6H8.8V6.4Z"
          fill={props.color}
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const NewCalendarIcon = (props) => (
  <svg
    style={props.style}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.8">
      <g clipPath="url(#clip0)">
        <path
          d="M3.54884 3.0306C3.34131 3.0306 3.1731 2.86239 3.1731 2.65486V0.37574C3.1731 0.168214 3.34131 0 3.54884 0C3.75636 0 3.92458 0.168214 3.92458 0.37574V2.65486C3.92458 2.86239 3.75636 3.0306 3.54884 3.0306Z"
          fill="#28328C"
        />
        <path
          d="M8.45118 3.0306C8.24365 3.0306 8.07544 2.86239 8.07544 2.65486V0.37574C8.07544 0.168214 8.24365 0 8.45118 0C8.65871 0 8.82692 0.168214 8.82692 0.37574V2.65486C8.82692 2.86239 8.65871 3.0306 8.45118 3.0306Z"
          fill="#28328C"
        />
        <path
          d="M0.569824 5.21289V10.3973C0.569824 11.2811 1.28883 12.0001 2.17261 12.0001H9.82749C10.7113 12.0001 11.4303 11.2811 11.4303 10.3973V5.21289H0.569824Z"
          fill="#28328C"
        />
        <path
          d="M11.4303 4.46142V2.74246C11.4303 1.85867 10.7113 1.13967 9.82746 1.13967H9.5784V2.65496C9.5784 3.27653 9.07274 3.78218 8.45118 3.78218C7.82961 3.78218 7.32396 3.27653 7.32396 2.65496V1.13965H4.67614V2.65494C4.67614 3.2765 4.17049 3.78216 3.54892 3.78216C2.92736 3.78216 2.4217 3.2765 2.4217 2.65494V1.13965H2.17261C1.28883 1.13965 0.569824 1.85865 0.569824 2.74244V4.4614H11.4303V4.46142Z"
          fill="#28328C"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ActionItemsIcon = (props) => (
  <svg
    style={props.style}
    width="13"
    height="11"
    viewBox="0 0 13 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 5L5.11713 6.88189C5.1929 6.94925 5.3071 6.94925 5.38287 6.88189L12 1"
      stroke={props.color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 1H8C8.09064 1 8.17988 1.00603 8.26733 1.01771C8.61037 1.06353 9 0.834576 9 0.488486C9 0.298037 8.88061 0.12496 8.69531 0.0809862C8.47215 0.0280299 8.23935 0 8 0H3C1.34315 0 0 1.34315 0 3V8C0 9.65685 1.34315 11 3 11H8C9.65685 11 11 9.65685 11 8V4.5C11 4.22386 10.7761 4 10.5 4C10.2239 4 10 4.22386 10 4.5V8C10 9.10457 9.10457 10 8 10H3C1.89543 10 1 9.10457 1 8V3C1 1.89543 1.89543 1 3 1Z"
      fill={props.color}
    />
  </svg>
);
export const TalkingPointsIcon = (props) => (
  <svg
    style={props.style}
    width="16"
    height="16"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.10657 3.46725C7.10657 2.81392 6.91991 2.16059 6.63991 1.60059H9.99991C11.6799 1.60059 12.9866 2.90725 12.9866 4.58725V7.57392C12.9866 9.23472 11.7586 10.4862 10.2994 10.6383C10.1346 10.6555 9.99991 10.7882 9.99991 10.9539V12.4503C9.99991 12.7029 9.70678 12.8424 9.51073 12.6831L7.09591 10.7211C7.04243 10.6776 6.97563 10.6539 6.90673 10.6539H4.58657C2.90657 10.6539 1.59991 9.34725 1.59991 7.66725V6.64059C2.15991 6.92059 2.71991 7.10725 3.46657 7.10725C5.42657 7.10725 7.10657 5.52059 7.10657 3.46725Z"
      fill={props.color}
    />
    <path
      d="M7.94652 1.60059C7.66652 2.16059 7.47985 2.81392 7.47985 3.46725C7.47985 5.52059 9.15985 7.10725 11.1199 7.10725C11.8665 7.10725 12.4265 6.92059 12.9865 6.64059V7.66725C12.9865 9.34725 11.6799 10.6539 9.99985 10.6539H7.57319H4.58652C2.99985 10.6539 1.59985 9.34725 1.59985 7.57392V4.58725C1.59985 2.90725 2.90652 1.60059 4.58652 1.60059H7.94652Z"
      fill={props.color}
    />
    <path
      d="M4.66675 7.33398H7.33341"
      stroke={props.strokeColor}
      strokeWidth="0.9008"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.58667 4.97363H10.1867"
      stroke={props.strokeColor}
      strokeWidth="0.9008"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TickIcon = (props) => (
  <svg
    width="11"
    height="8"
    viewBox="0 0 11 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 4.5L3.5 7L9.5 1"
      stroke="#01A87D"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const AddIcon = (props) => (
  <svg
    width="9"
    height="9"
    viewBox="0 0 9 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.028 4.932V3.51H4.806V0H3.24V3.51H0V4.932H3.24V8.586H4.806V4.932H8.028Z"
      fill="white"
    />
  </svg>
);

export const NewFilterIcon = (props) => (
  <svg
    style={props.style}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.4583 2.5H3.125C2.8125 2.5 2.5 2.8125 2.5 3.125C2.5 3.22917 2.5 3.4375 2.60417 3.54167L7.5 10.4167C7.70833 10.625 7.8125 10.9375 7.8125 11.25V16.875C7.8125 17.0833 7.91667 17.1875 8.02083 17.2917C8.125 17.3958 8.33333 17.5 8.4375 17.5C8.54167 17.5 8.64583 17.5 8.64583 17.5L11.3542 16.4583C11.5625 16.3542 11.7708 16.1458 11.7708 15.8333V11.25C11.7708 10.9375 11.875 10.625 12.0833 10.4167L16.9792 3.54167C17.0833 3.33333 17.0833 3.125 16.9792 2.91667C16.875 2.70833 16.6667 2.5 16.4583 2.5Z"
      fill="#8E9DB0"
    />
  </svg>
);

export const SurveyEmptyIcon = (props) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36.2512 30.8141H58.7501C59.4375 30.8141 60 30.2516 60 29.5641V26.4393C60 25.7518 59.4375 25.1893 58.7501 25.1893H36.2512C35.5637 25.1893 35.0012 25.7518 35.0012 26.4393V29.5641C35.0012 30.2516 35.5637 30.8141 36.2512 30.8141ZM36.2512 43.3135H58.7501C59.4375 43.3135 60 42.751 60 42.0635V38.9387C60 38.2512 59.4375 37.6887 58.7501 37.6887H36.2512C35.5637 37.6887 35.0012 38.2512 35.0012 38.9387V42.0635C35.0012 42.751 35.5637 43.3135 36.2512 43.3135ZM36.2512 55.8128H58.7501C59.4375 55.8128 60 55.2504 60 54.5629V51.4381C60 50.7506 59.4375 50.1881 58.7501 50.1881H36.2512C35.5637 50.1881 35.0012 50.7506 35.0012 51.4381V54.5629C35.0012 55.2504 35.5637 55.8128 36.2512 55.8128ZM25.0017 49.2507C22.9315 49.2507 21.205 50.9303 21.205 53.0005C21.205 55.0707 22.9315 56.7503 25.0017 56.7503C27.0719 56.7503 28.7515 55.0707 28.7515 53.0005C28.7515 50.9303 27.0719 49.2507 25.0017 49.2507ZM32.2279 25.8924L26.5876 31.5328L25.3689 32.7515C25.0017 33.1186 24.3611 33.1186 23.9939 32.7515L20.2754 29.0485C19.9082 28.6814 19.9082 28.0876 20.2754 27.7205L21.5019 26.494C21.869 26.1268 22.4628 26.1268 22.8299 26.494L24.6033 28.2204L29.5796 23.2754C29.9468 22.9082 30.5405 22.9082 30.9077 23.2754L32.2357 24.5644C32.5951 24.9315 32.5951 25.5253 32.2279 25.8924ZM32.2279 38.3606L26.5876 44.0009L25.3611 45.2274C24.9939 45.5946 24.3533 45.5946 23.9861 45.2274L20.2754 41.5167C19.9082 41.1495 19.9082 40.5558 20.2754 40.1886L21.5019 38.9621C21.869 38.5949 22.4628 38.5949 22.8299 38.9621L24.6033 40.6886L29.5796 35.7123C29.9468 35.3451 30.5405 35.3451 30.9077 35.7123L32.2357 37.0403C32.5951 37.3997 32.5951 37.9934 32.2279 38.3606Z"
      fill="#9799A9"
    />
    <circle cx="40" cy="40" r="39" stroke="#9799A9" strokeWidth="2" />
  </svg>
);

export const ArrowRightUp = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 10.5L10.5 1"
      stroke="#283288"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 1H10.5V8"
      stroke="#283288"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LeftArrowIcon = (props) => (
  <svg
    width="10"
    height="15"
    viewBox="0 0 10 15"
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.241393 6.91691L6.91726 0.241392C7.23911 -0.0804642 7.76123 -0.0804642 8.08309 0.241392L8.86179 1.0201C9.18331 1.34161 9.18365 1.86236 8.86317 2.18456L3.57228 7.49983L8.86282 12.8154C9.18365 13.1376 9.18296 13.6584 8.86145 13.9799L8.08274 14.7586C7.76089 15.0805 7.23877 15.0805 6.91691 14.7586L0.241393 8.08274C-0.0804642 7.76089 -0.0804642 7.23877 0.241393 6.91691Z"
      fill="#333333"
    />
  </svg>
);

export const EditIcon = (props) => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4768 8.98392L11.3101 8.15057C11.4404 8.02036 11.6669 8.1115 11.6669 8.29901V12.0855C11.6669 12.7757 11.107 13.3356 10.4169 13.3356H1.25003C0.559908 13.3356 0 12.7757 0 12.0855V2.91868C0 2.22856 0.559908 1.66866 1.25003 1.66866H8.37258C8.55748 1.66866 8.65123 1.89262 8.52102 2.02543L7.68767 2.85879C7.6486 2.89785 7.59652 2.91868 7.53923 2.91868H1.25003V12.0855H10.4169V9.12976C10.4169 9.07507 10.4377 9.02298 10.4768 8.98392ZM14.555 3.7286L7.71631 10.5673L5.36209 10.8277C4.67979 10.9032 4.09905 10.3277 4.17457 9.64018L4.43499 7.28597L11.2737 0.447275C11.87 -0.149092 12.8336 -0.149092 13.4274 0.447275L14.5524 1.5723C15.1488 2.16867 15.1488 3.13483 14.555 3.7286ZM11.982 4.5333L10.469 3.02025L5.63033 7.8615L5.44022 9.56206L7.14078 9.37195L11.982 4.5333ZM13.6696 2.45774L12.5445 1.33271C12.4378 1.22594 12.2633 1.22594 12.1591 1.33271L11.3544 2.13742L12.8675 3.65047L13.6722 2.84576C13.7763 2.73639 13.7763 2.56451 13.6696 2.45774Z"
      fill="black"
    />
  </svg>
);

export const FeaturedIcon = (props) => (
  <svg
    style={props.style}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.9757 6.41168L13.514 5.61542L11.0729 0.665893C10.6355 -0.216348 9.36823 -0.227563 8.9271 0.665893L6.48599 5.61542L1.02432 6.41168C0.0448775 6.55373 -0.347645 7.76121 0.362634 8.4528L4.31403 12.3033L3.37945 17.7425C3.21123 18.7257 4.24674 19.4621 5.11403 19.0023L10 16.4341L14.886 19.0023C15.7533 19.4584 16.7888 18.7257 16.6206 17.7425L15.686 12.3033L19.6374 8.4528C20.3476 7.76121 19.9551 6.55373 18.9757 6.41168ZM13.7607 11.6752L14.6467 16.849L10 14.4079L5.35328 16.849L6.23926 11.6752L2.47852 8.01167L7.67477 7.25654L10 2.54626L12.3252 7.25654L17.5215 8.01167L13.7607 11.6752Z"
      fill={props.color}
    />
  </svg>
);

export const SentIcon = (props) => (
  <svg
    style={props.style}
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.186 0.252942L0.935811 9.62413C-0.407952 10.4015 -0.279045 12.3898 1.15847 12.9796L5.62336 14.8273V18.1242C5.62336 19.9367 7.93588 20.6828 9.0062 19.2414L10.7172 16.9328L15.0883 18.7375C15.3188 18.8312 15.561 18.8781 15.8031 18.8781C16.1235 18.8781 16.4399 18.7961 16.725 18.6359C17.225 18.3547 17.5688 17.8547 17.6586 17.2883L19.979 2.16312C20.2172 0.596695 18.5375 -0.52441 17.186 0.252942ZM7.49838 18.1242V15.6007L8.92808 16.1906L7.49838 18.1242ZM15.8031 17.0031L9.79527 14.5226L15.2719 6.62019C15.6899 6.01472 14.9008 5.31159 14.3461 5.79206L6.0843 12.9913L1.87332 11.2491L18.1235 1.87405L15.8031 17.0031Z"
      fill={props.color}
    />
  </svg>
);

export const ClosedIcon = (props) => (
  <svg
    style={props.style}
    width="20"
    height="15"
    viewBox="0 0 20 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.125 0H1.875C0.839453 0 0 0.839453 0 1.875V13.125C0 14.1605 0.839453 15 1.875 15H18.125C19.1605 15 20 14.1605 20 13.125V1.875C20 0.839453 19.1605 0 18.125 0ZM18.125 1.875V3.46895C17.2491 4.18219 15.8528 5.29125 12.8677 7.62871C12.2098 8.14617 10.9067 9.38934 10 9.37484C9.09344 9.38949 7.78988 8.14598 7.13231 7.62871C4.14766 5.2916 2.75098 4.1823 1.875 3.46895V1.875H18.125ZM1.875 13.125V5.87492C2.77008 6.58785 4.03941 7.58828 5.97414 9.10328C6.82793 9.77535 8.32312 11.259 10 11.25C11.6686 11.259 13.1449 9.79688 14.0255 9.10359C15.9602 7.58863 17.2299 6.58793 18.125 5.87496V13.125H1.875Z"
      fill={props.color}
    />
  </svg>
);

export const PendingIcon = (props) => (
  <svg
    style={props.style}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.3198 6.42641C19.1363 6.27473 14.9556 2.91273 14.0365 2.18199C13.1731 1.49184 11.6968 0 10 0C8.3123 0 6.85016 1.47332 5.96348 2.18199C5.00789 2.94176 0.843555 6.29117 0.68418 6.42219C0.470259 6.59809 0.297959 6.8192 0.179662 7.06962C0.0613649 7.32004 7.85543e-06 7.59355 0 7.87051L0 18.125C0 19.1605 0.839453 20 1.875 20H18.125C19.1605 20 20 19.1605 20 18.125V7.87145C20 7.59536 19.939 7.32267 19.8214 7.07288C19.7038 6.82308 19.5325 6.60233 19.3198 6.42641ZM18.125 17.8906C18.125 17.9528 18.1003 18.0124 18.0564 18.0564C18.0124 18.1003 17.9528 18.125 17.8906 18.125H2.10938C2.04721 18.125 1.9876 18.1003 1.94365 18.0564C1.89969 18.0124 1.875 17.9528 1.875 17.8906V7.9823C1.875 7.91148 1.90688 7.84457 1.96195 7.80008C2.58188 7.29953 6.21168 4.38 7.13242 3.64801C7.84199 3.08125 9.07805 1.875 10 1.875C10.9255 1.875 12.1819 3.10035 12.8676 3.64801C13.7884 4.38008 17.4185 7.30008 18.0381 7.80098C18.0653 7.82293 18.0872 7.85069 18.1022 7.8822C18.1172 7.91372 18.125 7.9482 18.125 7.98312V17.8906ZM16.8754 10.5584C17.0413 10.76 17.0107 11.0582 16.8072 11.2218C15.6754 12.1313 14.4918 13.081 14.0365 13.443C13.1498 14.1517 11.6877 15.625 10 15.625C8.30266 15.625 6.82473 14.1314 5.96348 13.443C5.52289 13.0927 4.33285 12.1378 3.19289 11.2217C2.98937 11.0581 2.95879 10.7599 3.12473 10.5584L3.72074 9.83461C3.88395 9.63645 4.17609 9.60637 4.37617 9.76719C5.49406 10.6657 6.66391 11.6045 7.13242 11.977C7.81809 12.5246 9.07449 13.75 10 13.75C10.922 13.75 12.158 12.5437 12.8676 11.977C13.3361 11.6045 14.506 10.6657 15.6239 9.7673C15.824 9.60652 16.1162 9.6366 16.2793 9.83477L16.8754 10.5584Z"
      fill={props.color}
    />
  </svg>
);

export const CheckInIcon = (props) => (
  <svg
    width="15"
    height="21"
    viewBox="0 0 15 21"
    style={props.style}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.72922 20.3502C1.05352 11.8056 0 10.9287 0 7.78846C0 3.487 3.35785 0 7.5 0C11.6421 0 15 3.487 15 7.78846C15 10.9287 13.9465 11.8056 8.27078 20.3502C7.89832 20.9089 7.10164 20.9089 6.72922 20.3502ZM7.5 11.0337C9.2259 11.0337 10.625 9.58074 10.625 7.78846C10.625 5.99618 9.2259 4.54327 7.5 4.54327C5.7741 4.54327 4.375 5.99618 4.375 7.78846C4.375 9.58074 5.7741 11.0337 7.5 11.0337Z"
      fill={props.color ? props.color : "#9799A9"}
    />
  </svg>
);

export const PublicIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C4.47702 0 0 4.47702 0 10C0 15.523 4.47702 20 10 20C15.523 20 20 15.523 20 10C20 4.47702 15.523 0 10 0ZM13.3181 14.4194C13.1609 14.5758 12.996 14.7399 12.8621 14.8742C12.7415 14.9952 12.6565 15.1444 12.6133 15.306C12.5524 15.5343 12.5032 15.7649 12.421 15.9863L11.7198 17.8754C11.1649 17.9964 10.5907 18.0645 10 18.0645V16.9605C10.0681 16.4516 9.69193 15.4984 9.0875 14.894C8.84556 14.652 8.70968 14.3238 8.70968 13.9815V12.6907C8.70968 12.2214 8.45685 11.7899 8.04597 11.5629C7.46653 11.2423 6.64234 10.7944 6.07782 10.5101C5.61492 10.277 5.18669 9.98024 4.80161 9.63306L4.76935 9.60403C4.49398 9.35546 4.24948 9.07468 4.04113 8.76774C3.6629 8.2125 3.04677 7.29919 2.64637 6.70565C3.47177 4.87097 4.95927 3.39758 6.80766 2.59718L7.77581 3.08145C8.20484 3.29597 8.70968 2.98427 8.70968 2.50444V2.04879C9.03185 1.99677 9.35968 1.96371 9.69314 1.95121L10.8343 3.09234C11.0863 3.34435 11.0863 3.75282 10.8343 4.00484L10.6452 4.19355L10.2282 4.61048C10.1024 4.73629 10.1024 4.94073 10.2282 5.06653L10.4173 5.25564C10.5431 5.38145 10.5431 5.58589 10.4173 5.71169L10.0948 6.03427C10.0342 6.09472 9.9521 6.12866 9.86653 6.12863H9.50403C9.42016 6.12863 9.33952 6.16129 9.27903 6.22016L8.87903 6.60927C8.83 6.65702 8.79741 6.71911 8.78596 6.78659C8.7745 6.85406 8.78479 6.92343 8.81532 6.98468L9.44395 8.24234C9.55121 8.45685 9.39516 8.70927 9.15564 8.70927H8.92823C8.8504 8.70927 8.7754 8.68105 8.71694 8.63024L8.34274 8.30524C8.25806 8.23178 8.15572 8.18163 8.04579 8.15971C7.93585 8.13779 7.8221 8.14487 7.71573 8.18024L6.45887 8.59919C6.36291 8.63119 6.27946 8.69257 6.22033 8.77464C6.16121 8.85671 6.1294 8.9553 6.12944 9.05645C6.12944 9.23911 6.23266 9.40564 6.39597 9.4875L6.84274 9.71089C7.22218 9.90081 7.64073 9.9996 8.06492 9.9996C8.48911 9.9996 8.97581 11.1 9.35524 11.2899H12.0468C12.3891 11.2899 12.7169 11.4258 12.9593 11.6677L13.5113 12.2198C13.7419 12.4505 13.8714 12.7633 13.8714 13.0895C13.8713 13.3367 13.8224 13.5814 13.7274 13.8096C13.6325 14.0378 13.4934 14.2451 13.3181 14.4194ZM16.8145 10.7359C16.581 10.6774 16.3774 10.5343 16.244 10.3339L15.519 9.24637C15.4129 9.08748 15.3563 8.90072 15.3563 8.70968C15.3563 8.51863 15.4129 8.33187 15.519 8.17298L16.3089 6.98831C16.4024 6.84839 16.5306 6.73468 16.6815 6.65968L17.2048 6.39798C17.75 7.48347 18.0645 8.70444 18.0645 10C18.0645 10.3496 18.0347 10.6919 17.9911 11.0298L16.8145 10.7359Z"
      fill={props.color ? props.color : "#9799A9"}
    />
  </svg>
);

export const PrivateIcon = (props) => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9965 12.0427L15.9301 9.59736C16.0864 9.18719 15.7856 8.74968 15.3442 8.74968H13.059C13.4887 8.01138 13.7543 7.1637 13.7543 6.24961V6.23789C15.2856 5.93319 16.2544 5.49177 16.2544 4.99957C16.2544 4.48003 15.1879 4.01908 13.516 3.71047C13.1566 2.42919 12.4613 1.14009 11.93 0.476007C11.5589 0.0111497 10.9183 -0.133386 10.387 0.132247L9.30886 0.671325C8.95729 0.847111 8.54321 0.847111 8.19164 0.671325L7.11348 0.132247C6.58222 -0.133386 5.94158 0.0111497 5.57047 0.476007C5.04311 1.14009 4.34387 2.42919 3.98449 3.71047C2.31647 4.01908 1.25004 4.48003 1.25004 4.99957C1.25004 5.49177 2.21881 5.93319 3.75011 6.23789V6.24961C3.75011 7.1637 4.01574 8.01138 4.44544 8.74968H2.19928C1.75005 8.74968 1.44926 9.20673 1.62505 9.6208L2.63289 11.9724C1.06644 12.8826 0 14.5584 0 16.4999V18.25C0 19.2148 0.785178 20 1.75005 20H15.7504C16.7153 20 17.5005 19.2148 17.5005 18.25V16.4999C17.5005 14.6092 16.4927 12.9685 14.9965 12.0427ZM6.8752 18.75L5.25015 11.2498L7.1877 12.4998L8.12523 14.0623L6.8752 18.75ZM10.6253 18.75L9.37527 14.0623L10.3128 12.4998L12.2503 11.2498L10.6253 18.75ZM12.2543 7.08948C12.1019 7.55433 11.9808 8.05044 11.6097 8.3942C11.2152 8.75749 9.73465 9.26923 9.10963 7.41761C9.00026 7.08948 8.50805 7.08948 8.39477 7.41761C7.73069 9.3786 6.20721 8.68327 5.8947 8.3942C5.52359 8.05044 5.39859 7.55433 5.25015 7.08948C5.2189 6.99182 5.00405 6.86681 5.00405 6.86291V6.44102C6.10955 6.58165 7.38693 6.66759 8.75416 6.66759C10.1214 6.66759 11.3988 6.58556 12.5043 6.44102V6.86291C12.5004 6.86681 12.2855 6.98791 12.2543 7.08948Z"
      fill={props.color ? props.color : "#9799A9"}
    />
  </svg>
);

export const RightArrowPagination = (props) => (
  <svg
    width="7"
    height="10"
    viewBox="0 0 7 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.90771 5.38862L1.45728 9.83902C1.24264 10.0537 0.894658 10.0537 0.680042 9.83902L0.160974 9.31995C-0.0532988 9.10568 -0.0537109 8.75841 0.160058 8.54363L3.6871 4.99999L0.160058 1.45637C-0.0537109 1.24159 -0.0532988 0.89432 0.160974 0.680047L0.680042 0.160979C0.894681 -0.0536598 1.24267 -0.0536598 1.45728 0.160979L5.90768 4.61138C6.12232 4.826 6.12232 5.17398 5.90771 5.38862Z"
      fill={props.color || "#333333"}
    />
  </svg>
);

export const LeftArrowPagination = (props) => (
  <svg
    width="7"
    height="10"
    viewBox="0 0 7 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.160928 4.61128L4.6115 0.160928C4.82608 -0.0536428 5.17415 -0.0536428 5.38872 0.160928L5.90786 0.680067C6.1222 0.894409 6.12243 1.24157 5.90878 1.45637L2.38152 4.99989L5.90855 8.54363C6.12243 8.75843 6.12198 9.10559 5.90763 9.31993L5.38849 9.83907C5.17392 10.0536 4.82585 10.0536 4.61128 9.83907L0.160928 5.3885C-0.0536428 5.17392 -0.0536428 4.82585 0.160928 4.61128Z"
      fill={props.color || "#9799A9"}
    />
  </svg>
);

export const DownArrow = (props) => (
  <svg
    style={props.style}
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.324896 1.1417L0.325275 1.14133L1.14133 0.325275C1.4419 0.0246983 1.92714 0.025245 2.2236 0.324897L2.22398 0.325275L5.70483 3.80613L5.77554 3.87684L5.84625 3.80613L9.3271 0.325275C9.62768 0.0246983 10.1129 0.025245 10.4094 0.324897L10.4098 0.325275L11.2258 1.14133C11.5264 1.4419 11.5258 1.92714 11.2262 2.2236L11.2258 2.22398L6.31506 7.13472L6.31506 7.13472L6.31431 7.13549C6.02175 7.43441 5.53681 7.43552 5.23602 7.13472L0.325275 2.22398C0.0246982 1.9234 0.0252449 1.43817 0.324896 1.1417Z"
      fill="#333333"
      stroke="white"
      strokeWidth="0.2"
    />
  </svg>
);

export const DuplicateIcon = (props) => (
  <svg
    style={props.style}
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 0C0.447715 0 0 0.447716 0 1V8.53333C0 9.08562 0.447716 9.53333 1 9.53333H1.73336V2.73336C1.73336 2.18108 2.18108 1.73336 2.73336 1.73336H9.53333V1C9.53333 0.447715 9.08562 0 8.53333 0H1Z"
      fill="#333333"
    />
    <rect x="3.5" y="3.5" width="9" height="9" rx="0.5" stroke="#333333" />
    <path
      d="M8.744 8.68V9.832C8.744 10.1192 8.51119 10.352 8.224 10.352C7.93681 10.352 7.704 10.1192 7.704 9.832V8.68H6.504C6.22565 8.68 6 8.45435 6 8.176C6 7.89765 6.22565 7.672 6.504 7.672H7.696V6.52C7.696 6.23281 7.92881 6 8.216 6C8.50319 6 8.736 6.23281 8.736 6.52V7.672H9.936C10.2144 7.672 10.44 7.89765 10.44 8.176C10.44 8.45435 10.2144 8.68 9.936 8.68H8.744Z"
      fill="#333333"
    />
  </svg>
);

export const DragIcon = (props) => (
  <svg
    {...props}
    width="11"
    height="18"
    viewBox="0 0 11 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.6">
      <circle
        cx="2.6"
        cy="2.6"
        r="1.6"
        fill="#333333"
        stroke="#9799A9"
        strokeWidth="0.3"
      />
      <circle
        cx="2.6"
        cy="9.00002"
        r="1.6"
        fill="#333333"
        stroke="#9799A9"
        strokeWidth="0.3"
      />
      <circle
        cx="2.6"
        cy="15.4"
        r="1.6"
        fill="#333333"
        stroke="#9799A9"
        strokeWidth="0.3"
      />
      <circle
        cx="9.18789"
        cy="2.6"
        r="1.6"
        fill="#333333"
        stroke="#9799A9"
        strokeWidth="0.3"
      />
      <circle
        cx="9.18789"
        cy="9.00002"
        r="1.6"
        fill="#333333"
        stroke="#9799A9"
        strokeWidth="0.3"
      />
      <circle
        cx="9.18789"
        cy="15.4"
        r="1.6"
        fill="#333333"
        stroke="#9799A9"
        strokeWidth="0.3"
      />
    </g>
  </svg>
);

export const BulbPrimaryIcon = (props) => (
  <svg
    {...props}
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0918 7.15002C10.5884 7.15002 10.1983 7.54008 10.1983 8.02165C10.1983 8.50322 10.5884 8.89327 11.0918 8.89327C11.5515 8.89327 11.9416 8.50322 11.9416 8.02165C11.9416 7.54008 11.5515 7.15002 11.0918 7.15002ZM4.99039 7.15002C4.48703 7.15002 4.09698 7.54008 4.09698 8.02165C4.09698 8.50322 4.48703 8.89327 4.99039 8.89327C5.45017 8.89327 5.84022 8.50322 5.84022 8.02165C5.84022 7.54008 5.45017 7.15002 4.99039 7.15002Z"
      fill="#4652B7"
    />
    <path
      d="M18.0859 5.4922C17.0777 4.10445 15.624 3.10454 13.9675 2.65943V2.66161C13.5949 2.24758 13.1743 1.86625 12.7036 1.52632C9.1365 -1.06676 4.12903 -0.275765 1.52505 3.29135C-0.573383 6.1895 -0.484042 10.0878 1.65579 12.8574L1.67323 15.7469C1.67323 15.8166 1.68412 15.8863 1.70591 15.9517C1.73332 16.039 1.77768 16.1201 1.83644 16.1902C1.89521 16.2604 1.96723 16.3183 2.04839 16.3606C2.12955 16.4029 2.21825 16.4287 2.30942 16.4367C2.40059 16.4447 2.49244 16.4347 2.57972 16.4071L5.3384 15.5377C6.06839 15.797 6.82234 15.9451 7.57194 15.9865L7.56104 15.9953C9.50259 17.4095 12.0477 17.8344 14.3815 17.063L17.1511 17.9651C17.2208 17.9869 17.2927 18 17.3668 18C17.7525 18 18.0641 17.6884 18.0641 17.3027V14.3828C19.9839 11.7766 20.034 8.17462 18.0859 5.4922ZM5.64347 13.9905L5.38199 13.8816L3.22472 14.5571L3.20293 12.2909L3.0286 12.0948C1.18512 9.84596 1.06309 6.6057 2.7889 4.22835C4.88952 1.34763 8.91642 0.711348 11.7884 2.79017C14.6691 4.88425 15.3076 8.90461 13.2266 11.7679C11.4812 14.1627 8.3564 15.0474 5.64347 13.9905Z"
      fill="#4652B7"
    />
    <path
      d="M8.04108 7.15002C7.53771 7.15002 7.14766 7.54008 7.14766 8.02165C7.14766 8.50322 7.53771 8.89327 8.04108 8.89327C8.50086 8.89327 8.89091 8.50322 8.89091 8.02165C8.89091 7.54008 8.50086 7.15002 8.04108 7.15002Z"
      fill="#4652B7"
    />
  </svg>
);

export const TableDropdownButton = ({ selected }) => (
  <svg
    width="21"
    height="22"
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ filter: "drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.08))" }}
  >
    <rect
      x="0.5"
      y="21.5"
      width="21"
      height="20"
      rx="4.5"
      transform="rotate(-90 0.5 21.5)"
      fill={selected ? "#4652B7" : "#F7F7FF"}
      stroke="#E5E5F3"
    />
    <path
      d="M5 14.5003C5 14.83 5.09775 15.1522 5.28088 15.4263C5.46402 15.7004 5.72432 15.914 6.02886 16.0401C6.3334 16.1663 6.66852 16.1993 6.99182 16.135C7.31512 16.0707 7.61209 15.9119 7.84518 15.6788C8.07827 15.4457 8.237 15.1488 8.30131 14.8255C8.36562 14.5022 8.33261 14.1671 8.20647 13.8625C8.08032 13.558 7.8667 13.2977 7.59262 13.1145C7.31853 12.9314 6.9963 12.8337 6.66667 12.8337C6.22464 12.8337 5.80072 13.0093 5.48816 13.3218C5.17559 13.6344 5 14.0583 5 14.5003ZM5 8.66699C5 8.99663 5.09775 9.31886 5.28088 9.59294C5.46402 9.86702 5.72432 10.0806 6.02886 10.2068C6.3334 10.3329 6.66852 10.3659 6.99182 10.3016C7.31512 10.2373 7.61209 10.0786 7.84518 9.8455C8.07827 9.61241 8.237 9.31544 8.30131 8.99214C8.36562 8.66884 8.33261 8.33373 8.20647 8.02919C8.08032 7.72464 7.8667 7.46435 7.59262 7.28121C7.31853 7.09807 6.9963 7.00033 6.66667 7.00033C6.22464 7.00033 5.80072 7.17592 5.48816 7.48848C5.17559 7.80104 5 8.22496 5 8.66699Z"
      fill={selected ? "white" : "#4652B7"}
    />
    <path
      d="M12 14.5003C12 14.83 12.0977 15.1522 12.2809 15.4263C12.464 15.7004 12.7243 15.914 13.0289 16.0401C13.3334 16.1663 13.6685 16.1993 13.9918 16.135C14.3151 16.0707 14.6121 15.9119 14.8452 15.6788C15.0783 15.4457 15.237 15.1488 15.3013 14.8255C15.3656 14.5022 15.3326 14.1671 15.2065 13.8625C15.0803 13.558 14.8667 13.2977 14.5926 13.1145C14.3185 12.9314 13.9963 12.8337 13.6667 12.8337C13.2246 12.8337 12.8007 13.0093 12.4882 13.3218C12.1756 13.6344 12 14.0583 12 14.5003ZM12 8.66699C12 8.99663 12.0977 9.31886 12.2809 9.59294C12.464 9.86702 12.7243 10.0806 13.0289 10.2068C13.3334 10.3329 13.6685 10.3659 13.9918 10.3016C14.3151 10.2373 14.6121 10.0786 14.8452 9.8455C15.0783 9.61241 15.237 9.31544 15.3013 8.99214C15.3656 8.66884 15.3326 8.33373 15.2065 8.02919C15.0803 7.72464 14.8667 7.46435 14.5926 7.28121C14.3185 7.09807 13.9963 7.00032 13.6667 7.00032C13.2246 7.00032 12.8007 7.17592 12.4882 7.48848C12.1756 7.80104 12 8.22496 12 8.66699Z"
      fill={selected ? "white" : "#4652B7"}
    />
  </svg>
);
